/**
 * @file Промежуточное значение для короткой анимации счётчика.
 *
 * Интерполяция приближает число к уже известной цели. Она не оценивает скорость
 * сети и не добавляет неподтверждённые байты.
 */
// Двигаем отображение к подтверждённому значению, не предсказывая расход трафика.
export function interpolateProgress(
    from: number,
    to: number,
    elapsed: number,
    duration = 180,
): number {
    const fraction = Math.min(1, Math.max(0, elapsed / duration))

    return Math.round(from + (to - from) * (1 - (1 - fraction) ** 3))
}
